/* eslint-disable max-len */
import {pathWithParams, apiVersion, DEFAULT_TIMEOUT, setErrorApi} from '@/utils/constants';
import {handleErrorCustom} from '@/utils/errorHandling';
import {sucessCustom} from '@/utils/successHandling';
import {useAxios} from '@sttedra_ui/framework';

// #region Globals
const {base} = useAxios();
const servicio = 'PermisoPantalla';
// #endregion

async function postFilterPermisoPantalla(_datafilter) {
  const url = `${pathWithParams()}${servicio}/PantallaFilter?${apiVersion}`;
  try {
    const {data: response} = await base.post(url, _datafilter, {timeout: DEFAULT_TIMEOUT});
    return response.objetoSalida;
  } catch (error) {
    if (error.code === 'ERR_NETWORK') setErrorApi();
    handleErrorCustom(error);
  }
}

async function getPermisoPantallaAvailable(_tipoPantallaId) {
  const url = `${pathWithParams()}${servicio}/Available?tipoPantallaId=${_tipoPantallaId}&${apiVersion}`;
  try {
    const {data: response} = await base.get(url, {timeout: DEFAULT_TIMEOUT});
    return response.objetoSalida;
  } catch (error) {
    if (error.code === 'ERR_NETWORK') setErrorApi();
    handleErrorCustom(error);
  }
}

async function getPermisoPantallaSelected(_tipoPantallaId) {
  const url = `${pathWithParams()}${servicio}/Selected?tipoPantallaId=${_tipoPantallaId}&${apiVersion}`;
  try {
    const {data: response} = await base.get(url, {timeout: DEFAULT_TIMEOUT});
    return response.objetoSalida;
  } catch (error) {
    if (error.code === 'ERR_NETWORK') setErrorApi();
    handleErrorCustom(error);
  }
}

async function postAddPermisoPantalla(_data) {
  const url = `${pathWithParams()}${servicio}?${apiVersion}`;
  try {
    const {data: response} = await base.post(url, _data, {timeout: DEFAULT_TIMEOUT});
    sucessCustom(response.message);
    return response.success;
  } catch (error) {
    if (error.code === 'ERR_NETWORK') setErrorApi();
    handleErrorCustom(error);
  }
}

async function getListPermisoPantalla() {
  const url = `${pathWithParams()}${servicio}/ListPermisoPantalla?${apiVersion}`;
  try {
    const {data: response} = await base.get(url, {timeout: DEFAULT_TIMEOUT});
    return response.objetoSalida;
  } catch (error) {
    if (error.code === 'ERR_NETWORK') setErrorApi();
    handleErrorCustom(error);
  }
}

export {
  postFilterPermisoPantalla,
  getPermisoPantallaAvailable,
  getPermisoPantallaSelected,
  postAddPermisoPantalla,
  getListPermisoPantalla,
};
